import { State } from '@/stores/approvals/state';
import { Actions } from '@/stores/approvals/actions';
import { Getters } from '@/stores/approvals/getters';
import { Mutations } from '@/stores/approvals/mutations';
import { Module } from 'vuex';

export class ApprovalStore implements Module<State, any> {
    public namespaced: boolean = true;
    public state: State = new State();
    public actions: Actions = new Actions();
    public getters: Getters = new Getters();
    public mutations: Mutations = new Mutations();
}
